import { useEffect } from "react";
import { useInView } from "react-intersection-observer";

/**
 * A simple hook to trigger a callback when an element comes into view.
 * @param callback - The function to call (e.g., fetchNextPage)
 * @param condition - A boolean to prevent firing (e.g., hasNextPage && !isFetching)
 */
export default function useInfiniteScrollTrigger(
  callback: () => void,
  condition: boolean = true
) {
  const { ref, inView } = useInView();

  useEffect(() => {
    // 1. Only run if the element is visible
    // 2. Only run if the external condition (hasNextPage) is met
    if (inView && condition) {
      callback();
    }
  }, [inView, condition, callback]);

  return { ref };
}
